/**
 * Collection Product Showcase — Indiana Jerky Theme
 * Handles sidebar category accordion + flavor switching.
 * Shows one product panel at a time.
 */
(function () {
  'use strict';

  var section = document.querySelector('.main-collection');
  if (!section) return;

  var categoryHeaders = section.querySelectorAll('[data-category-toggle]');
  var flavorButtons = section.querySelectorAll('[data-flavor-select]');
  var panels = section.querySelectorAll('[data-product-panel]');

  if (!categoryHeaders.length || !panels.length) return;

  /**
   * Expand a category's flavor sub-menu and collapse others.
   */
  function openCategory(categoryKey) {
    categoryHeaders.forEach(function (header) {
      var cat = header.getAttribute('data-category-toggle');
      var flavorsEl = header.nextElementSibling;

      if (cat === categoryKey) {
        header.classList.add('is-active');
        header.setAttribute('aria-expanded', 'true');
        if (flavorsEl) flavorsEl.classList.add('is-open');
      } else {
        header.classList.remove('is-active');
        header.setAttribute('aria-expanded', 'false');
        if (flavorsEl) flavorsEl.classList.remove('is-open');
      }
    });
  }

  /**
   * Show a specific product panel by panel ID.
   */
  function showPanel(panelId) {
    panels.forEach(function (panel) {
      if (panel.getAttribute('data-product-panel') === panelId) {
        panel.hidden = false;
        panel.classList.add('is-active');
        // Re-trigger animation
        panel.style.animation = 'none';
        panel.offsetHeight; // Force reflow
        panel.style.animation = '';
      } else {
        panel.hidden = true;
        panel.classList.remove('is-active');
      }
    });

    // Update active flavor button
    flavorButtons.forEach(function (btn) {
      if (btn.getAttribute('data-flavor-select') === panelId) {
        btn.classList.add('is-active');
      } else {
        btn.classList.remove('is-active');
      }
    });

    // Update URL without reload
    var url = new URL(window.location);
    url.searchParams.set('flavor', panelId);
    window.history.replaceState({}, '', url);
  }

  // --- Event Listeners ---

  // Category header click → toggle accordion
  categoryHeaders.forEach(function (header) {
    header.addEventListener('click', function () {
      var categoryKey = header.getAttribute('data-category-toggle');
      var flavorsEl = header.nextElementSibling;
      var isOpen = flavorsEl && flavorsEl.classList.contains('is-open');

      if (isOpen) {
        // If already open, close it
        header.classList.remove('is-active');
        header.setAttribute('aria-expanded', 'false');
        if (flavorsEl) flavorsEl.classList.remove('is-open');
      } else {
        // Open this category, close others
        openCategory(categoryKey);

        // Auto-select first flavor in the opened category
        if (flavorsEl) {
          var firstFlavor = flavorsEl.querySelector('[data-flavor-select]');
          if (firstFlavor) {
            var panelId = firstFlavor.getAttribute('data-flavor-select');
            showPanel(panelId);
          }
        }
      }
    });
  });

  // Flavor button click → show corresponding panel
  flavorButtons.forEach(function (btn) {
    btn.addEventListener('click', function () {
      var panelId = btn.getAttribute('data-flavor-select');
      showPanel(panelId);
    });
  });

  // --- Initialize from URL ---
  var urlParams = new URLSearchParams(window.location.search);
  var initialFlavor = urlParams.get('flavor');
  if (initialFlavor) {
    // Find the category for this flavor
    var targetBtn = section.querySelector('[data-flavor-select="' + initialFlavor + '"]');
    if (targetBtn) {
      var parentCategory = targetBtn.closest('[data-sidebar-category]');
      if (parentCategory) {
        var catKey = parentCategory.getAttribute('data-sidebar-category');
        openCategory(catKey);
      }
      showPanel(initialFlavor);
    }
  }

  // --- Mobile sidebar collapse / expand ---
  var sidebar = section.querySelector('.collection-sidebar');
  var sidebarToggle = section.querySelector('[data-sidebar-toggle]');
  if (sidebar && sidebarToggle) {
    sidebarToggle.addEventListener('click', function () {
      var isExpanded = sidebar.getAttribute('data-sidebar-expanded') === 'true';
      sidebar.setAttribute('data-sidebar-expanded', isExpanded ? 'false' : 'true');
      sidebarToggle.setAttribute('aria-expanded', isExpanded ? 'false' : 'true');
    });

    // When a flavor button is clicked on mobile, auto-collapse the sidebar
    flavorButtons.forEach(function (btn) {
      btn.addEventListener('click', function () {
        if (window.matchMedia('(max-width: 900px)').matches) {
          sidebar.setAttribute('data-sidebar-expanded', 'false');
          sidebarToggle.setAttribute('aria-expanded', 'false');
          // Scroll the product panel into view so the user sees the result
          var activePanel = section.querySelector('[data-product-panel]:not([hidden])');
          if (activePanel) {
            activePanel.scrollIntoView({ behavior: 'smooth', block: 'start' });
          }
        }
      });
    });
  }

})();
